/**
 * @generated SignedSource<<78a6e6635ce8090276e256a96fab2970>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedMakeOfferButton_user$data = {
  readonly preferences: {
    readonly currency: Currency | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_user">;
  readonly " $fragmentType": "PdpSharedMakeOfferButton_user";
};
export type PdpSharedMakeOfferButton_user$key = {
  readonly " $data"?: PdpSharedMakeOfferButton_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedMakeOfferButton_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedMakeOfferButton_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_user"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserPreferences",
      "kind": "LinkedField",
      "name": "preferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "2285fa98e26b357f2eacf10f54ff1dde";

export default node;
